import { render, staticRenderFns } from "./OfficeCategories.vue?vue&type=template&id=70f927f1&"
import script from "./OfficeCategories.vue?vue&type=script&lang=js&"
export * from "./OfficeCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports